// extracted by mini-css-extract-plugin
module.exports = {"BuildControl":"BuildControl_BuildControl__80-4h","Label":"BuildControl_Label__1x2Od","Less":"BuildControl_Less__25PgY","More":"BuildControl_More__3zXtu"};